import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import { hashHistory, Link } from 'react-router';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { Modal, Input, message, Button, Icon } from 'antd';

export default class ChooseStudentsModule extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      role: CurrentRoleStore.getCurrentRole(),
      pageId: props.pageId,
      templateId: props.templateId,
      studentIds: props.studentIds,
      archiveId: null,
      classId: props.classId,

      visible: props.visible,
      author: props.author,
      teacherDo: true,
      students: [],
      selected: [],
      multiSelect: false,
      selectFinished: [],
      selectDraft: [],
      needFresh: false,

      isShowParentHasFinished: false,
      isShowParentAllUnfinished: false,
      isShowTeacherMultiSelect: false,

      // 是否可以多选学生
      studentSelectType: props.studentSelectType,
      templateType: props.templateType,
    };
    // bind this
    this.selectStudent = this.selectStudent.bind(this);
    this.toViewPage = this.toViewPage.bind(this);
    this.toFillPage = this.toFillPage.bind(this);
    this.toFillPageWarn = this.toFillPageWarn.bind(this);
    this.toFillPageNoWarn = this.toFillPageNoWarn.bind(this);
    this.onHideBox = this.onHideBox.bind(this);
  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onRolesChange);
  }

  componentWillUnmount() {
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  componentWillReceiveProps(newProps){
    if(newProps.classId && newProps.pageId){
      DataService.getClassStatus(newProps.classId, newProps.pageId).then((res) => {
        let students = [];
        let status = ['completes', 'drafts', 'unsubmits'];

        DataService.getArchiveStudentList(newProps.archiveId).then((data) => {
          status.map((item) => {
            res[item].map((stu) => {
              let child = data.students.find((student) => student.id == stu.id), viweonly = false;
              if (child && (child.archive_status == 'confirm')) {
                viweonly = true;
              }
              students.push({
                name: stu.full_name,
                id: stu.id,
                state: viweonly ? 'viweonly' : item,
                page_content_id: stu.page_content_id ? stu.page_content_id : 0 
              })
            })
          })

          students.sort((a, b) => {
            return a.id - b.id;
          })

          this.setState({
            students: students,
            pageId: newProps.pageId,
            classId: newProps.classId,
            templateId: newProps.templateId,
            teacherDo: this.state.author === 'teacher',
            needFresh: false,
            visible: newProps.visible,
            selected: [],
            selectFinished: [],
            archiveId: newProps.archiveId,
            studentSelectType: newProps.studentSelectType,
            templateType: newProps.templateType
          })
        }).catch((error) => {
          console.log(error);
        });
      })
    }
  }

  selectStudent (e) {
    let [index, state, selected, student, multiSelect, selectFinished, selectDraft, studentSelectType, templateType] = [
        e.currentTarget.dataset.index,
        e.currentTarget.dataset.state,
        [...this.state.selected],
        [...this.state.students],
        false,
        [...this.state.selectFinished],
        [...this.state.selectDraft],
        this.state.studentSelectType,
        this.state.templateType
      ];

    // 故事模板 - 是否只能选择单个学生评价
    if (studentSelectType == 'one' && templateType == 'story') {
      selected = [];
      student = student.map(s => {
        if (s.selected) {
          s.selected = ''
        }
        return s
      });
      selectFinished = [];
      selectDraft = []
    }

    if (selected.indexOf(index) >= 0) {
      selected.splice(selected.indexOf(index), 1);
      student[index].selected = '';
    } else if (student[index].state != 'viweonly'){
      selected.push(index);
      student[index].selected = 'selected';
    }

    if (selectFinished.indexOf(index) >= 0) {
      selectFinished.splice(selectFinished.indexOf(index), 1);
    } else if (student[index].state === 'completes') {
      selectFinished.push(index);
    }

    if (selectDraft.indexOf(index) >= 0) {
      selectDraft.splice(selectDraft.indexOf(index), 1);
    } else if (student[index].state === 'drafts') {
      selectDraft.push(index);
    }

    if (selected.length > 1 || (selected.length === 1 && student[selected[0]].state !== 'completes')) {
      multiSelect = true;
    }

    this.setState({
      selected: selected,
      students: student,
      multiSelect: multiSelect,
      selectFinished: selectFinished,
      selectDraft: selectDraft
    })
  }

  toViewPage () {
    let warn = !this.state.teacherDo;
    let id = this.state.students[this.state.selected[0]].id;
    let pageContentId = this.state.students[this.state.selected[0]].page_content_id;
    let { templateType } = this.state;
    if (templateType == 'story') {
      hashHistory.push(`archive/record/story/?studentIds=[${id}]&pageId=${this.state.pageId}&templateId=${this.state.templateId}&status=changeable&warn=${warn}&archiveId=${this.state.archiveId}&pageContentId=${pageContentId}&classId=${this.state.classId}`);
      return
    }
    hashHistory.push(`archive/record/edit/?studentIds=[${id}]&pageId=${this.state.pageId}&templateId=${this.state.templateId}&status=changeable&warn=${warn}&archiveId=${this.state.archiveId}`);
  }

  toFillPage () {
    var that = this;
    var studentIds = this.state.selected.map(function(studentIndex) {
      return that.state.students[studentIndex].id;
    });
    if (this.state.selectFinished.length > 0 && !this.state.teacherDo) {  // 家长，存在已完成
      this.setState({isShowParentHasFinished: true})
    } else if (!this.state.teacherDo) {  // 家长，全部为未完成
      this.setState({isShowParentAllUnfinished: true})
    } else if ((this.state.selectFinished.length === 0 && this.state.selectDraft.length === 0) || (this.state.selected.length === 1 && this.state.selectDraft.length === 1)) {  // 全部为未填写或选择了一个草稿
      if (this.state.templateType == 'story') {
        hashHistory.push(`archive/record/story/?studentIds=${JSON.stringify(studentIds)}&pageId=${this.state.pageId}&templateId=${this.state.templateId}&status=changeable&archiveId=${this.state.archiveId}&classId=${this.state.classId}`);
        return
      }
      hashHistory.push(`archive/record/edit/?studentIds=${JSON.stringify(studentIds)}&pageId=${this.state.pageId}&templateId=${this.state.templateId}&archiveId=${this.state.archiveId}`);
    } else {  // 老师填写，包含多个草稿或者已完成
      this.setState({isShowTeacherMultiSelect: true})
    }
  }

  toFillPageWarn(){
    var that = this;
    var studentIds = this.state.selected.map(function(studentIndex) {
      return that.state.students[studentIndex].id;
    });
    hashHistory.push(`archive/record/edit/?studentIds=${JSON.stringify(studentIds)}&pageId=${this.state.pageId}&templateId=${this.state.templateId}&warn=true&archiveId=${this.state.archiveId}`)
  }

  toFillPageNoWarn(){
    var that = this;
    var studentIds = this.state.selected.map(function(studentIndex) {
      return that.state.students[studentIndex].id;
    });
    if (this.state.templateType == 'story') {
      hashHistory.push(`archive/record/story/?studentIds=${JSON.stringify(studentIds)}&pageId=${this.state.pageId}&templateId=${this.state.templateId}&status=changeable&archiveId=${this.state.archiveId}&classId=${this.state.classId}`);
      return
    }
    hashHistory.push(`archive/record/edit/?studentIds=${JSON.stringify(studentIds)}&pageId=${this.state.pageId}&templateId=${this.state.templateId}&archiveId=${this.state.archiveId}`)
  }

  // 家长，存在已完成
  _parentHasFinished(){
    return (
      <Modal
        title="有小孩已完成"
        okText="确认编辑"
        visible={this.state.isShowParentHasFinished}
        onOk={this.toFillPageWarn}
        onCancel={this.onHideBox}
      >
        <p>你选中的小孩中已有家长填写完成，若点击继续编辑则会清空家长填写的内容，是否继续编辑？</p>
      </Modal>
    )
  }

  // 家长，全部为未完成
  _parentAllUnfinished(){
    return (
      <Modal
        title="该主题为家长填写"
        okText="确认编辑"
        visible={this.state.isShowParentAllUnfinished}
        onOk={this.toFillPageWarn}
        onCancel={this.onHideBox}
      >
        <p>该主题为家长填写，是否继续编辑？</p>
      </Modal>
    )
  }

  // 老师填写，包含多个草稿或者已完成
  _teacherMultiSelect(){
    return (
      <Modal
        title="已有内容将会清空"
        okText="确认编辑"
        visible={this.state.isShowTeacherMultiSelect}
        onOk={this.toFillPageNoWarn}
        onCancel={this.onHideBox}
      >
        <p>选中的{this.state.selectFinished.length + this.state.selectDraft.length}个小孩已填写过，确认编辑则会清空本页已经填写过的所有内容，重新开始填写</p>
      </Modal>
    )
  }

  onHideBox(){
    this.setState({
      isShowParentHasFinished: false,
      isShowParentAllUnfinished: false,
      isShowTeacherMultiSelect: false,
    })
  }

  render() {
    return (
      <Modal
        className="choose-students-modal"
        visible={this.state.visible}
        onCancel={this.props.onCancel}
        title="选择宝贝"
        footer={[
          <div>
            {this.state.selected.length === 0 && this.state.teacherDo && <div className="bottom-explain">请选择宝贝</div>}
            {(this.state.selected.length > 0 || !this.state.teacherDo) &&
              <div className="bottom-btn">
                {this.state.selectFinished.length === 1 && this.state.selected.length === 1 && <div className="select-finished" onClick={this.toViewPage}>去查看 <div className="icon-align"></div></div>}
                {this.state.multiSelect && (this.state.selected.length > 0 || !this.state.teacherDo) &&
                  <div className="select" onClick={this.toFillPage}>
                    <div className="btn-box">
                      <div className="multi-select">
                        {this.state.teacherDo && <div className="multi-select-bold">去填写</div>}
                        {this.state.teacherDo && <div className="multi-select-thin">已选{this.state.selected.length}人</div>}
                        {!this.state.teacherDo && <div className="multi-select-bold">去填写</div>}
                        {!this.state.teacherDo && <div className="multi-select-thin">该主题家长填写中...</div>}
                      </div>
                      {this.state.teacherDo && <div className="align"><div className="icon-align"></div></div>}
                    </div>
                  </div>
                }
                {this.state.selected.length == 0 && !this.state.teacherDo && 
                  <div className="select">
                    <div className="multi-select-bold" style={{textAlign: 'center'}} >请选择宝贝</div>
                  </div>
                }
              </div>
            }
          </div>
        ]}
      >
        <div className="student-list">
          {this.state.students.map((student, index)=>
            <div key={index} className={"student-item " + (student.state ? student.state : "") + " " + (student.selected ? student.selected : "")} onClick={this.selectStudent} data-index={index} >
              {student.state === 'completes' && <Icon type="check" size="11" color="#5B6273" />}
              {student.state === 'drafts' && <div className="draft-icon"></div>}
              {student.name}
            </div>
          )}
         </div>
        {this._teacherMultiSelect()}
        {this._parentAllUnfinished()}
        {this._parentHasFinished()}
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/ChooseStudentsModule.jsx